export const UPDATE_SESSION = 'UPDATE_SESSION';
export const SESSION_RESET_STATE = 'SESSION_RESET_STATE';
